// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"go-z","badgeLink":"ho-z","category":"io-z"};